import React from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  useColorModeValue,
  Flex,
} from '@chakra-ui/react';
import Pagination from '../common/Pagination';

export default function CustomTable({
  columns = [], // [{ header: 'Header', accessor: 'fieldName' }]
  data = [],
  renderActions = null, // (row) => <ActionButton row={row} />
  showCheckbox = false, // If you want to show checkboxes for selection
  checkedItems = [], // Array of checked item IDs
  onCheck = () => {},
  paginationProps = null, // { currentPage, totalPages, onPageChange }
}) {
  const tableHeaderBg = useColorModeValue('orange.100', 'orange.300');
  const rowHoverBg = useColorModeValue('orange.50', 'orange.900');

  return (
    <>
      <TableContainer boxShadow={'xl'} overflow="scroll">
        <Table variant="simple" size="md">
          <Thead bg={tableHeaderBg}>
            <Tr>
              {showCheckbox && <Th></Th>}
              {columns.map((col, idx) => (
                <Th key={idx}>{col.header}</Th>
              ))}
              {renderActions && <Th>アクション</Th>}
            </Tr>
          </Thead>
          <Tbody>
            {data.map((row, rowIndex) => (
              <Tr
                key={rowIndex}
                _hover={{
                  bg: rowHoverBg,
                  transition: '0.2s',
                }}
              >
                {showCheckbox && (
                  <Td>
                    <input
                      type="checkbox"
                      onChange={(e) => onCheck(e, row.id)}
                      checked={checkedItems.includes(row.id)}
                    />
                  </Td>
                )}
                {columns.map((col, colIndex) => (
                  <Td key={colIndex}>
                    {col.Cell ? col.Cell(row) : row[col.accessor] || ''}
                  </Td>
                ))}
                {renderActions && (
                  <Td>
                    <Flex gap={2}>{renderActions(row)}</Flex>
                  </Td>
                )}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>

      {/* Optional Pagination */}
      {paginationProps && (
        <Flex justify="center" mt={8}>
          <Pagination
            currentPage={paginationProps.currentPage}
            totalPages={paginationProps.totalPages}
            onPageChange={paginationProps.onPageChange}
          />
        </Flex>
      )}
    </>
  );
}
